import type { ReactNode } from 'react';

import { Tooltip } from '@arco-design/web-react';

import styles from './group-spec-card.module.less';

interface CardSubtitleTooltipProps {
  children: ReactNode;
  /** 完整文案，悬停时在 Tooltip 中展示 */
  tooltip?: string;
}

/** 卡片副标题：单行省略，完整内容通过 Tooltip 展示 */
export function CardSubtitleTooltip({ children, tooltip }: CardSubtitleTooltipProps) {
  const subtitle = <div className={styles.cardSubtitle}>{children}</div>;
  if (!tooltip) return subtitle;
  return <Tooltip content={tooltip}>{subtitle}</Tooltip>;
}
